module.exports = __webpack_public_path__ + "img/avatar1.3bf23cd2.png";